module.exports = __webpack_public_path__ + "img/user.333cc8db.svg";